module.exports = __webpack_public_path__ + "img/mobilenewsLogo8.d087bb22.png";